export const MY_PROFILE_PATH = "/profile";
